import React from 'react'
import PortraitWarningGraphic from './PortraitWarningGraphic'
import BrowserDetect from 'browser-detect'

class PortraitWarning extends React.Component{
  shouldComponentUpdate(){
    const b = new BrowserDetect()
    return(b.mobile)
  }
  render(){
    const style = {
      top: '50%',
      transform: 'translate(0px, -50%)',
      MsTransform: 'translate(0px, -50%)',
      position: 'fixed',
      margin: '0 auto',
      width: '100%',
      backgroundColor: 'rgba(255,255,255,0.9)',
      height: '100%',
    }
    const wrapperStyle = {
      position: 'relative',
      top: '50%',
      transform: 'translateY(-50%)',
      MsTransform: 'translateY(-50%)',
      margin: '0 auto',
      maxWidth: '80%',
    }
    const b = new BrowserDetect()
    if(!b.mobile){
      return null
    }
    return(
      <div style={style} id="portrait-warning">
        <div id="portrait-warning" style={wrapperStyle}>
          <PortraitWarningGraphic/>
        </div>
      </div>
    )
  }
}

export default PortraitWarning



// WEBPACK FOOTER //
// ./src/PortraitWarning.js